const calcVH = () => {
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};

calcVH();

window.addEventListener('resize', () => {
  calcVH();
});

const getOffsetTop = (element) => {
  let offsetTop = 0

  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop
    }
  } while ((element = element.offsetParent))

  return offsetTop
};

const isInViewports = (element) => {
  const windowBottom = window.scrollY + window.innerHeight;

  return windowBottom >= getOffsetTop(element);
};

[...document.querySelectorAll('[data-fade-in]')].forEach((element) => {
  ['load', 'scroll', 'shopify:section:load'].forEach((eventName) => {
    window.addEventListener(eventName, () => {

      if (!isInViewports(element)) {
        return;
      };

      element.classList.add('fade-in');
    });
  });
});

// Cookies
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  let nameEQ = name + '=';
  let ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; path=/; Max-Age=-99999999;';
}

// End Cookies

// Cookie modal
const cookieModal = document.querySelector('.js-cookie-modal');
const closeCookieModal = document.querySelector('.js-close-cookie');
const cookieActive = getCookie('cookie_modal');

if (!cookieActive) {
  cookieModal.classList.remove('is-hidden');
}

closeCookieModal.addEventListener('click', () => {
  cookieModal.classList.add('is-hidden');
  setCookie('cookie_modal', 'none', 30)
});

// Newsletter modal
const newsletterHandler = function () {
  const newsletterCookieActive = getCookie('cookie_newsletter');
  const closeNewsletterBtn = document.querySelector('.js-newsletter-close');
  const backToShoppingBtn = document.querySelector('.js-newsletter-btn');
  const newsletter = document.querySelector('.js-newsletter');
  const overlay = document.querySelector('.js-overlay');
  const challenge = [...document.querySelectorAll('.shopify-challenge__container')];
  const newsletterFormWrapper = document.querySelector('.js-newsletter-form');

  if (!newsletter) {
    return;
  }

  const openNewsletter = (delay = 0) => {
    setTimeout(() => {
      newsletter.classList.remove('is-hidden');
      overlay.classList.remove('is-hidden');
      bodyScrollLock.disableBodyScroll(newsletter);
    }, delay);
  }

  const closeNewsletter = (event) => {
    event.preventDefault();

    overlay?.classList.add('is-hidden');
    newsletter?.classList.add('is-hidden');
    setCookie('cookie_newsletter', 'none', 30);
    bodyScrollLock.enableBodyScroll(newsletter);
  }

  if (!newsletterCookieActive) {
    const isSubmitted = newsletterFormWrapper.classList.contains('is-submitted');
    const isNotSubmitted = newsletterFormWrapper.classList.contains('is-not-submitted');
    const hasErrors = newsletterFormWrapper.classList.contains('has-errors');
    const openedModal = hasErrors || isNotSubmitted || isSubmitted;

    if (openedModal) {
      openNewsletter();
    }

    if (challenge.length === 0 && !openedModal) {
      openNewsletter(5000);
    }
  }

  backToShoppingBtn?.addEventListener('click', closeNewsletter);
  overlay?.addEventListener('click', closeNewsletter);
  closeNewsletterBtn?.addEventListener('click', closeNewsletter);
}

newsletterHandler();

// Header
const header = document.querySelector('.js-header');

window.addEventListener('scroll', (e) => {
  if (window.scrollY > 0) {
    header.classList.add('is-scrolled');
  } else {
    header.classList.remove('is-scrolled');
  }
})


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Nav

const navTriggers = [...document.querySelectorAll('.js-nav-trigger')];
const closeNavTrigger = [...document.querySelectorAll('.js-close-nav')];

const initNav = (e) => {
  e.preventDefault();

  const headerNav = document.querySelector('.header__nav');
  const target = e.target;
  const navScrollContainer = [...headerNav.querySelectorAll('.js-nav-scroll-container')];

  headerNav.classList.toggle('is-translated');
  bodyScrollLock.disableBodyScroll(headerNav);
  navScrollContainer.forEach((container) => {
    bodyScrollLock.disableBodyScroll(container);
  });

  if (target.classList.contains('js-close-nav')) {
    bodyScrollLock.enableBodyScroll(headerNav);
    navScrollContainer.forEach((container) => {
      bodyScrollLock.enableBodyScroll(container);
    });
  }
};

closeNavTrigger.forEach(close => close.addEventListener('click', initNav));
navTriggers.forEach(trigger => trigger.addEventListener('click', initNav));

document.querySelector('.js-nav-items').addEventListener('click', function(e) {

  if (e.target.classList.contains('nav__link--lvl-1') && e.target.parentElement.classList.contains('has-items')) {
     e.preventDefault();

     e.target.nextElementSibling.classList.add('is-visible');
    }

    if (e.target.classList.contains('js-nav-back'))
    e.preventDefault();

    e.target.parentElement.classList.remove('is-visible');
});

//Component Typewriter

const typewriter = (target) => {
  const sectionEntry = target.querySelector('.js-section-entry');

  const sectionEntryParagraphs = [...sectionEntry.querySelectorAll('p')];

  sectionEntryParagraphs.forEach(paragraph => {
    const characters = paragraph.innerText.split('');
    const htmlCharacters = characters.map(character => {
      const span = document.createElement('span');
      const spanContent = document.createTextNode(character);
      span.appendChild(spanContent);
      return span;
    });

    paragraph.innerHTML = '';

    htmlCharacters.forEach((para, index) => {
      const timeout = (index + 1) * 20;

      setTimeout(() => {
        para.style.color = '#000';
      }, timeout);

      paragraph.insertAdjacentElement("beforeend", para);
    });
  });

  sectionEntry.setAttribute('data-is-executed', 'true');
};

const initTypewriter = function(entries, observer) {
  const [entry] = entries;

  const isExecuted = (entry.target.querySelector('.js-section-entry').dataset.isExecuted == "true")
  if (!entry.isIntersecting || isExecuted) {
    return;
  }

  typewriter(entry.target);
}

const sectionObserver = new IntersectionObserver(initTypewriter, {
  root: null,
  threshold: 0.25,
  rootMargin: '0px 0px -25%'
});

const sectionTextual = [...document.querySelectorAll('.js-section-textual')];

sectionTextual.forEach(section => sectionObserver.observe(section));

[...document.querySelectorAll('[id^="Details-"] summary')].forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  [...document.querySelectorAll('.js-youtube')].forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  [...document.querySelectorAll('.js-vimeo')].forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  [...document.querySelectorAll('video')].forEach((video) => video.pause());
  [...document.querySelectorAll('product-model')].forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    [...this.querySelectorAll('button')].forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

window.addEventListener('shopify:section:load', () => {
  [...document.querySelectorAll('[data-fade-in]')].forEach((element) => {
    ['load', 'scroll', 'shopify:section:load'].forEach((eventName) => {
      window.addEventListener(eventName, () => {
        if (!isInViewports(element)) {
          return;
        };

        element.classList.add('fade-in');
      });
    });
  });
})

function resizeVideos(iframes) {
  if (iframes.length === 0) return;

  [...iframes].forEach((video) => {
    const videoWidth = video.getAttribute('width');
    const videoHeight = video.getAttribute('height');
    if (!videoWidth || !videoHeight) return;

    const videoAspectRatio = (videoHeight / videoWidth);
    const parentDiv = video.parentNode;
    const parentWidth = parentDiv.clientWidth;
    const parentHeight = parentDiv.clientHeight;
    const parentAspectRatio = (parentHeight / parentWidth);

    if (videoAspectRatio > parentAspectRatio) {
      video.style.width = parentWidth + 'px';
      video.style.height = videoHeight * (parentWidth / videoWidth) + 'px';
    } else {
      video.style.height = parentHeight + 'px';
      video.style.width = videoWidth * (parentHeight / videoHeight) + 'px';
    }
  });
}

class youtubeVideo extends HTMLElement {
  constructor() {
    super();
    this.youtubeVideo = [...document.querySelectorAll('youtube-video')];
    this.videos = [];

    [...this.youtubeVideo].forEach((youtubeVideo) => {
      [...youtubeVideo.querySelectorAll('[data-id]')].forEach((element) => {
        this.videos.push(element);
      });
    });

    this.iframes = [];
    this.players = [];

    window.addEventListener('resize', debounce(this.videoResizer.bind(this), 500));
  }

  connectedCallback() {
    if (this.videos.length == 0) return;

    [...this.videos].forEach((video) => {
      this.players.push(video);
    });

    this.init(this.players);
  }

  init(videos) {
    window.onYouTubeIframeAPIReady = () => {
      [...videos].forEach((video) => {
        const player = new YT.Player(video, {
          videoId: video.dataset.id,
          playerVars: {
            autoplay: 1,
            playsinline: 1,
            loop: 1,
            controls: 0,
            showinfo: 0,
            modestbranding: 1,
            fs: 0,
            cc_load_policy: 0,
            iv_load_policy: 3,
            autohide: 0,
          },
          events: {
            onReady: (event) => {
              event.target.mute();
              event.target.playVideo();

              this.iframes.push(event.target.h);
              this.videoResizer();
            },
            onStateChange: (event) => {
              if (event.data == 0) {
                event.target.playVideo();
              }
            }
          }
        });
      });
    }
  }

  videoResizer() {
    resizeVideos(this.iframes);
  }
}

customElements.define('youtube-video', youtubeVideo);

class vimeoVideo extends HTMLElement {
  constructor() {
    super();
    this.iframes = [...this.querySelectorAll('iframe')];
  }

  connectedCallback() {
    if (this.iframes.length == 0) return;

    window.addEventListener('load', debounce(this.videoResizer.bind(this), 500));
    window.addEventListener('resize', debounce(this.videoResizer.bind(this), 500));
  }

  videoResizer() {
    resizeVideos(this.iframes);
  }
}

customElements.define('vimeo-video', vimeoVideo);

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;
        this.form = this.querySelector('form');
        this.form.querySelector('[name="id"]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.compactMode = this.hasAttribute('data-compact');
      }

      onSubmitHandler(event) {
        event.preventDefault();
        if (!this.submitButton || this.submitButton.classList.contains('is-loading')) return;

        !this.compactMode && this.handleErrorMessage();
        this.cartDrawer.setActiveElement(document.activeElement);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('is-loading');

        const fetchedData = this.addItemToCart();
        this.handleFetchedData(fetchedData);
      }

      addItemToCart() {
        return new Promise((resolve, reject) => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const quantityInput = this.querySelector('.js-quantity-input');

          const formData = new FormData(this.form);

          if (quantityInput) {
            formData.append('quantity', quantityInput.value);
          }

          formData.append(
            'sections',
            this.cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response) {
                resolve(response);

                // Dispatch cartChange event for Free samples logic.
                window.dispatchEvent(
                  new Event('cartChange', { bubbles: true })
                );
                return;
              }

              this.submitButton.classList.remove('is-loading');
              this.submitButton.removeAttribute('aria-disabled');

              reject(response);
            })
            .catch((e) => {
              window.console.error(error);
            });
        });
      }

      handleFetchedData(promise) {
        Promise.all([promise])
          .then((values) => {
            if (values.length === 0) {
              return;
            }

            const fetchedData = values[0];

            if (fetchedData.status && !this.compactMode) {
              this.handleErrorMessage(fetchedData.description);
              return;
            }

            this.cartDrawer.handleAddedItem(fetchedData);

            const quickview = document.querySelector(
              `#Product-Quickview-${this.productId}`
            );

            if (quickview) {
              quickview.hide();
            }
          })
          .catch((error) => {
            window.console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('is-loading');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.main-product__form-error-message-wrapper');
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.main-product__form-error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
